import React, { useContext, useEffect, useRef } from 'react'
import { AudioContext } from './conversation'

function AudioPlayer() {
  const { isPlaying, currentTime, duration, setCurrentTime, handleOnClick } = useContext(
    AudioContext
  )
  const restTime = duration - currentTime
  const inputRef = useRef()

  useEffect(() => {
    inputRef.current.value = (currentTime / duration) * 100
  }, [currentTime])

  function handleOnChange(e) {
    setCurrentTime(parseFloat(e.target.value))
  }

  useEffect(() => {
    inputRef.current.value = currentTime
  }, [])

  const minutes = (restTime >= 0 ? Math.floor(restTime / 60) : 0).toString()
  const seconds = (restTime >= 0 ? Math.round(restTime % 60) : 0).toString()

  return (
    <div className="audio-player">
      <button onClick={handleOnClick}><svg viewBox="0 0 20 20" height="15px" width="15px">{
        isPlaying 
          ?
        <>
          <rect x="3" y="3" width="5" height="14" fill="black" />
          <rect x="12" y="3" width="5" height="14" fill="black" />
        </>
          : 
        <path d="M17 10L4.25 17.7942L4.25 2.20577L17 10Z" fill="black" />
      }</svg></button>
      <input
        ref={inputRef}
        onChange={handleOnChange}
        type="range"
        min="0"
        max="100"
        defaultValue="0"
      />
      <span>
        &minus;
        <time dateTime={`PT${minutes}M${seconds}S`}>
          {`${minutes.padStart(2, '0')}:${seconds.padStart(2, '0')}`}
        </time>
      </span>
    </div>
  )
}

export default AudioPlayer
